import CarouselWidget from './CarouselWidget';

export default CarouselWidget;
